import { FILE_LOADER_FILE_ERROR } from "../../../../Controls/metricsAction";
import { track } from "../../../../Controls/Internals/Metrics/MetricsProvider";
import {
    ICandyApiDraftAttachmentsClient,
    ICandyApiDraftTasksClient,
} from "../../../../../../Common/CandyApiClient/ICandyApiClient";
import { VerifyAndFixFnsRequirementsTask } from "../../../Api/CandyApiClient/VerifyAndFixFnsRequirementsTask";
import { KREC_ERROR_CHECK, KREC_ERROR_CONVERT } from "../../../Core/ErrorManager/ErrorManager";
import { FormStore } from "../../../Core/Store/CandyStore";
import { IModelValidationsAccessor } from "../../../Form/IFormModelAccessor";
import { setAttachmentProgress, updateAttachment } from "../Store/AttachmentsActions";
import { createFileError } from "../../../../Controls/ValueEditors/FileLoader/ViewFile/FileError";
import { TaskInfoError } from "../../../../../../Common/CandyApiClient/Types/Tasks/Tasks";

import { ITask } from "./ITask";

export class ConvertTask implements ITask {
    private readonly task: VerifyAndFixFnsRequirementsTask;
    private readonly attachmentId: string;
    private readonly bindingPath: string;
    private readonly modelAccessor: IModelValidationsAccessor;
    private readonly store: FormStore;
    private readonly candyApiDraftClient: ICandyApiDraftAttachmentsClient;
    private cancelled = false;
    public taskPromise: Promise<void>;

    public constructor(
        store: FormStore,
        modelAccessor: IModelValidationsAccessor,
        candyApiDraftClient: ICandyApiDraftAttachmentsClient & ICandyApiDraftTasksClient,
        attachmentId: string,
        bindingPath: string
    ) {
        this.modelAccessor = modelAccessor;
        this.store = store;
        this.attachmentId = attachmentId;
        this.bindingPath = bindingPath;
        this.candyApiDraftClient = candyApiDraftClient;
        this.task = new VerifyAndFixFnsRequirementsTask(candyApiDraftClient, attachmentId, attachmentId);
        this.taskPromise = this.executeTask();
    }

    public cancel(): void {
        this.cancelled = true;
        // Пока так, если упадёт, то мы ничего не можем сделать.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.cancel();
    }

    public writeResult = async (): Promise<undefined> => {
        const attachment = await this.candyApiDraftClient.getAttachmentById(this.attachmentId);

        const nextAttachment = {
            ...attachment,
            meta: {
                ...attachment.meta,
                progress: 100,
                isConverted: true,
            },
        };

        this.store.dispatch(updateAttachment(this.attachmentId, nextAttachment));
        await this.candyApiDraftClient.createOrUpdateAttachments([nextAttachment]);
        return undefined;
    };

    private async executeTask(): Promise<void> {
        try {
            this.task.progress(this.handleChangeTaskProgress);
            await this.task.startTask();
            if (this.cancelled) {
                return;
            }
            await this.writeResult();
        } catch (e) {
            // @ts-ignore
            this.handleTaskError(e);
        }
    }

    private readonly handleChangeTaskProgress = (current: number, total: number) => {
        const percent = total > 0 ? Math.floor((current / total) * 20) : 0;
        this.store.dispatch(setAttachmentProgress(this.attachmentId, percent + 80));
    };

    private readonly handleTaskError = (error: TaskInfoError): undefined => {
        track("candy", FILE_LOADER_FILE_ERROR, {
            path: this.bindingPath,
            attachmentId: this.attachmentId,
        });

        // @ts-ignore Разобраться с ошибками
        if (error.code === "Cancelled") {
            return undefined;
        }

        // Когда `properties == null` - то проверка сломалась (с) Алексей Мухачев
        if (!error.properties) {
            const message = createFileError(KREC_ERROR_CHECK);
            // @ts-ignore Ужасно, надо переделать, но пока лучше так
            this.modelAccessor.setWarning(this.bindingPath, message);
        }

        // Когда `properties != null && 'fileCheckResult' in properties` - то конвертация сломалась (с) Алексей Мухачев
        if (error.properties && "fileCheckResult" in error.properties) {
            const message = createFileError(KREC_ERROR_CONVERT);
            // @ts-ignore Ужасно, надо переделать, но пока лучше так
            this.modelAccessor.setError(this.bindingPath, message);
        }
        return undefined;
    };
}
